"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEpics = createEpics;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var uploadActions = require("./actions");
var errorHandling_1 = require("@caddigital/sok-reducers/lib/utils/errorHandling");
var PARALLEL_UPLOADS = 10;
var CHUNK_SIZE = 1024 * 10; // 10kiB
var encode = function (data) { return btoa(unescape(encodeURIComponent(data))); };
var encodeMetadata = function (metadata) {
    var encoded = [];
    for (var key in metadata) {
        encoded.push(key + ' ' + encode(metadata[key] + ''));
    }
    return encoded.join(',');
};
function createEpics(prefix, getState) {
    var actions = uploadActions.createActions(prefix);
    var initFileUploadRequestAction = "".concat(prefix, "/FILEUPLOAD_REQUEST");
    function initFileUpload(action$, store, fetchOptions) {
        return action$.pipe((0, operators_1.filter)(function (action) {
            return action.type === initFileUploadRequestAction;
        }), (0, operators_1.throttleTime)(2000), (0, operators_1.switchMap)(function (action) {
            var session = getState(store.value).currentUploadStatus.session;
            if (!session) {
                return fetchOptions
                    .ajax({
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: fetchOptions.getToken()
                    },
                    url: "".concat(fetchOptions.baseUrl, "api/files/upload-session"),
                    body: {
                        parentFolderUUID: action.payload.parent.uuid
                    },
                    method: 'POST'
                })
                    .pipe((0, operators_1.flatMap)(function (res) {
                    return (0, rxjs_1.of)(actions.uploadSessionCreated(__assign(__assign({}, action.payload), { bidUuid: store.value.bid.current.bid
                            ? store.value.bid.current.bid.uuid
                            : undefined, briefcaseUuid: store.value.briefcase.current.briefcase
                            ? store.value.briefcase.current.briefcase.uuid
                            : undefined, letterUuid: store.value.bid.currentAddendum.bid
                            ? store.value.bid.currentAddendum.bid.uuid
                            : undefined }), res.response.uuid, res.response.project));
                }), (0, operators_1.catchError)(function (e) {
                    return (0, rxjs_1.of)(actions.uploadSessionFailed((0, errorHandling_1.parseAjaxErrorResponse)(e)));
                }));
            }
            else {
                return fetchOptions
                    .ajax({
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: fetchOptions.getToken()
                    },
                    url: "".concat(fetchOptions.baseUrl, "api/files/upload-session/").concat(session),
                    method: 'GET'
                })
                    .pipe((0, operators_1.flatMap)(function (res) {
                    return (0, rxjs_1.of)(actions.uploadSessionCreated(__assign(__assign({}, action.payload), { bidUuid: store.value.bid.current.bid
                            ? store.value.bid.current.bid.uuid
                            : undefined, briefcaseUuid: store.value.briefcase.current.briefcase
                            ? store.value.briefcase.current.briefcase.uuid
                            : undefined, letterUuid: store.value.bid.currentAddendum.bid
                            ? store.value.bid.currentAddendum.bid.uuid
                            : undefined }), res.response.uuid, res.response.project));
                }), (0, operators_1.catchError)(function (e) {
                    return (0, rxjs_1.of)(actions.uploadSessionFailed((0, errorHandling_1.parseAjaxErrorResponse)(e)));
                }));
            }
        }));
    }
    function handleUpload(payload, subject, fetchOptions) {
        var xhr;
        var isAborted = false;
        var uuid = payload.uploadItem.uuid;
        var file = payload.uploadItem.file;
        return new rxjs_1.Observable(function (observer) {
            if (!file) {
                observer.next(actions.fileuploadFileFailure('invalid payload', uuid));
                observer.complete();
                return;
            }
            var unzip = payload.unzip === false &&
                file.name.split('.').pop() === 'zip' &&
                (file.type === 'application/zip' ||
                    file.type === 'application/x-zip-compressed');
            // Add metadata if values have been added
            var metadata = '';
            if (payload.letterUuid) {
                metadata = encodeMetadata({
                    filename: file.name,
                    filetype: file.type,
                    parent: payload.parent.id,
                    project: payload.parent.project,
                    projectUuid: payload.parent.projectUuid,
                    parentUUID: payload.parent.uuid,
                    session: payload.session,
                    unzip: unzip,
                    replace: payload.replace || false,
                    file: payload.fileId,
                    bidUuid: payload.bidUuid,
                    letterUuid: payload.letterUuid,
                    briefcaseUuid: payload.briefcaseUuid
                });
            }
            else {
                metadata = encodeMetadata({
                    filename: file.name,
                    filetype: file.type,
                    parent: payload.parent.id,
                    project: payload.parent.project,
                    projectUuid: payload.parent.projectUuid,
                    parentUUID: payload.parent.uuid,
                    session: payload.session,
                    unzip: unzip,
                    replace: payload.replace || false,
                    file: payload.fileId
                });
            }
            // Initialize slice reader
            var total = file.size;
            var _ = new Promise(function (resolve, reject) {
                if (!unzip) {
                    resolve(200);
                    return;
                }
                var xhrC = new XMLHttpRequest();
                var chunk = file.slice(Math.max(0, file.size - CHUNK_SIZE), file.size);
                xhrC.open('POST', "".concat(fetchOptions.uploadServerUrl, "/files/verify"), true);
                xhrC.setRequestHeader('Upload-Offset', '' + Math.max(0, file.size - CHUNK_SIZE));
                xhrC.setRequestHeader('Upload-Length', '' + Math.min(file.size, CHUNK_SIZE));
                xhrC.setRequestHeader('Content-Size', '' + file.size);
                xhrC.setRequestHeader('Upload-Metadata', metadata);
                xhrC.setRequestHeader('Content-Type', 'application/offset+octet-stream');
                xhrC.setRequestHeader('Authorization', fetchOptions.getToken());
                xhrC.onreadystatechange = function () {
                    if (xhrC.readyState !== 4) {
                        return;
                    }
                    if (xhrC.status === 200) {
                        var offset = xhrC.getResponseHeader('Upload-Offset');
                        var size = xhrC.getResponseHeader('Upload-Length');
                        var chunk2 = file.slice(offset, file.size);
                        var xhr2_1 = new XMLHttpRequest();
                        xhr2_1.open('PATCH', "".concat(fetchOptions.uploadServerUrl, "/files/verify"), true);
                        xhr2_1.setRequestHeader('Upload-Offset', '' + offset);
                        xhr2_1.setRequestHeader('Upload-Length', '' + size);
                        xhr2_1.setRequestHeader('Content-Size', '' + file.size);
                        xhr2_1.setRequestHeader('Upload-Metadata', metadata);
                        xhr2_1.setRequestHeader('Content-Type', 'application/offset+octet-stream');
                        xhr2_1.setRequestHeader('Authorization', fetchOptions.getToken());
                        xhr2_1.onreadystatechange = function () {
                            if (xhr2_1.readyState === 4) {
                                if (xhr2_1.status === 200) {
                                    resolve(xhr2_1.status);
                                    return;
                                }
                                else {
                                    reject(xhr2_1.status);
                                    return;
                                }
                            }
                        };
                        xhr2_1.send(chunk2);
                    }
                    else if (xhrC.status !== 200) {
                        reject(xhrC.status);
                    }
                };
                xhrC.send(chunk);
            })
                .catch(function (err) {
                subject.complete();
                var error;
                switch (err) {
                    case 401:
                        error = 'Permission denied';
                        break;
                    default:
                        error = 'Network error';
                }
                observer.next(actions.fileuploadFileFailure(error, uuid));
                observer.complete();
                return Promise.reject(err);
            })
                .then(function () {
                xhr = new XMLHttpRequest();
                xhr.open('POST', "".concat(fetchOptions.uploadServerUrl, "/files/"), true);
                xhr.setRequestHeader('Upload-Metadata', metadata);
                xhr.setRequestHeader('Authorization', fetchOptions.getToken());
                xhr.setRequestHeader('Upload-Offset', JSON.stringify(0));
                xhr.setRequestHeader('Upload-Length', JSON.stringify(total));
                xhr.setRequestHeader('Content-Type', 'application/offset+octet-stream');
                subject.next(actions.fileuploadFileUpdateStatus(0, 0, total, uuid));
                xhr.upload.onprogress = function (e) {
                    // Append progress percentage.
                    var loaded = e.loaded;
                    var total = e.total;
                    // Update the progress
                    subject.next(actions.fileuploadFileUpdateStatus(Math.floor((loaded / total) * 100), loaded, total, uuid));
                };
                xhr.onreadystatechange = function () {
                    if (!xhr) {
                        return;
                    }
                    if (isAborted === true) {
                        subject.complete();
                        observer.complete();
                        return;
                    }
                    if (xhr.readyState !== 4) {
                        return;
                    }
                    subject.complete();
                    if (xhr.status !== 200) {
                        observer.next(actions.fileuploadFileFailure('Permission denied', uuid));
                        observer.complete();
                        return;
                    }
                    observer.next(actions.fileuploadFileSuccess(payload.parent.project, uuid, payload.session));
                    observer.complete();
                    return;
                };
                // Handle xhr failure
                xhr.onerror = function () {
                    observer.next(actions.fileuploadFileFailure('Unable connect server 2', uuid));
                    observer.complete();
                };
                xhr.send(file);
            })
                .catch(console.error);
        }).pipe((0, operators_1.finalize)(function () {
            isAborted = true;
            xhr && xhr.abort();
        }), (0, operators_1.catchError)(function (a) { return (0, rxjs_1.of)(a); }));
    }
    var handleFileUploadRequestAction = "".concat(prefix, "/UPLOAD_SESSION_CREATED");
    var handleFileUploadCancelAction = "".concat(prefix, "/FILEUPLOAD_CANCEL");
    var handleFileUploadDoneAction = "".concat(prefix, "/FILEUPLOAD_DONE");
    function handleFileUpload(action$, store, fetchOptions) {
        var fileuploadFileUpdateAction = "".concat(prefix, "/FILEUPLOAD_FILE_UPDATE");
        var fileuploadFileSuccessAction = "".concat(prefix, "/FILEUPLOAD_FILE_SUCCESS");
        var fileuploadFileFailureAction = "".concat(prefix, "/FILEUPLOAD_FILE_FAILURE");
        var fileuploadFileCancelAction = "".concat(prefix, "/FILEUPLOAD_FILE_CANCEL");
        return action$.pipe((0, operators_1.filter)(function (action) {
            return action.type === handleFileUploadRequestAction;
        }), (0, operators_1.mergeMap)(function (a) {
            return (0, rxjs_1.of)(a).pipe((0, operators_1.mergeMap)(function (data) {
                var upload$ = (0, rxjs_1.of)(data.payload)
                    .pipe((0, operators_1.mergeMap)(function (x) {
                    return rxjs_1.of.apply(void 0, x.payload.structure.map(function (item) { return ({
                        parent: x.payload.parent,
                        unzip: x.payload.unzip,
                        replace: x.payload.replace,
                        fileId: x.payload.fileId,
                        uploadItem: item,
                        session: x.session,
                        bidUuid: x.payload.bidUuid,
                        briefcaseUuid: x.payload.briefcaseUuid,
                        letterUuid: x.payload.letterUuid
                    }); }));
                }), (0, operators_1.mergeMap)(function (payload) {
                    var subject = new rxjs_1.ReplaySubject();
                    var query = handleUpload(payload, subject, fetchOptions);
                    var cancel = action$.pipe((0, operators_1.filter)(function (action) {
                        return action.type === handleFileUploadCancelAction;
                    }), (0, operators_1.map)(function () {
                        return actions.fileuploadFileCancel(payload.uploadItem.uuid);
                    }));
                    var merged = (0, rxjs_1.merge)(subject, (0, rxjs_1.race)(query, cancel).pipe((0, operators_1.take)(1)));
                    return merged;
                }, undefined, PARALLEL_UPLOADS), (0, operators_1.bufferTime)(500), (0, operators_1.mergeMap)(function (actions) {
                    var actionList = [];
                    var actionMap = {};
                    var total = actions.length;
                    for (var i = 0; i < total; i++) {
                        var action = actions[i];
                        if (action.type === fileuploadFileUpdateAction ||
                            action.type === fileuploadFileSuccessAction ||
                            action.type === fileuploadFileFailureAction ||
                            action.type === fileuploadFileCancelAction) {
                            if (actionMap[action.type] === undefined) {
                                actionMap[action.type] = action.payload;
                            }
                            else {
                                actionMap[action.type] = actionMap[action.type].concat(action.payload);
                            }
                        }
                        else {
                            actionList.push(action);
                        }
                    }
                    Object.entries(actionMap).forEach(function (act) {
                        actionList.push({
                            type: act[0],
                            payload: act[1]
                        });
                    });
                    return rxjs_1.of.apply(void 0, actionList);
                }))
                    .pipe((0, operators_1.takeUntil)(action$.pipe((0, operators_1.filter)(function (action) {
                    return action.type === handleFileUploadCancelAction ||
                        action.type === handleFileUploadDoneAction;
                }))));
                return upload$;
            }), (0, operators_1.catchError)(function (a) { return (0, rxjs_1.of)(a); }));
        }));
    }
    var cancelUploadSessionRequestAction = "".concat(prefix, "/FILEUPLOAD_CANCEL");
    function cancelUploadSession(action$, _store, fetchOptions) {
        return action$.pipe((0, operators_1.filter)(function (action) {
            return action.type === cancelUploadSessionRequestAction;
        }), (0, operators_1.mergeMap)(function (action) {
            return fetchOptions
                .ajax({
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: fetchOptions.getToken()
                },
                url: "".concat(fetchOptions.uploadServerUrl, "/files/session/").concat(action.payload),
                method: 'DELETE'
            })
                .pipe((0, operators_1.flatMap)(function () {
                return (0, rxjs_1.of)(actions.abortSessionSuccessAction());
            }), (0, operators_1.catchError)(function (e) {
                return (0, rxjs_1.of)(actions.abortSessionFailureAction(e));
            }));
        }));
    }
    var setFileUploadFiles = "".concat(prefix, "/SET_FILEUPLOAD_FILES");
    function checkDuplicateFolder(action$, store, fetchOptions) {
        return action$.pipe((0, operators_1.filter)(function (action) {
            return action.type === setFileUploadFiles;
        }), (0, operators_1.mergeMap)(function (action) {
            if (!action.payload.parent) {
                return (0, rxjs_1.empty)();
            }
            return fetchOptions
                .ajax({
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: fetchOptions.getToken()
                },
                url: "".concat(fetchOptions.baseUrl, "api/files/check-existing"),
                body: {
                    files: action.payload.files.map(function (x) { return ({
                        name: x.name,
                        type: x.file ? x.file.type : ''
                    }); }),
                    parent: action.payload.parent.id
                },
                timeout: 3600000,
                method: 'POST'
            })
                .pipe((0, operators_1.timeout)(360000), (0, operators_1.flatMap)(function (_a) {
                var response = _a.response;
                return (0, rxjs_1.of)(actions.checkDuplicateFilesSuccess(response.data));
            }), (0, operators_1.catchError)(function (e) {
                return (0, rxjs_1.of)(actions.checkDuplicateFilesFailure(false));
            }));
        }));
    }
    function saveMetas(session, fetchOptions, successActionFn, errorActionFn, state) {
        // Get metas
        // Save metas
        return (0, rxjs_1.of)(session).pipe((0, operators_1.mergeMap)(function (session) {
            return fetchOptions
                .ajax({
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: fetchOptions.getToken()
                },
                method: 'POST',
                body: {
                    hierarchyType: 'SESSION',
                    sessionUuid: session,
                    metas: {}
                },
                url: "".concat(fetchOptions.baseUrl, "api/files/metadata/save")
            })
                .pipe((0, operators_1.flatMap)(function () {
                return rxjs_1.of.apply(void 0, successActionFn(state));
            }));
        }));
    }
    var successAction = "".concat(prefix, "/FILEUPLOAD_FILE_SUCCESS");
    var failureAction = "".concat(prefix, "/FILEUPLOAD_FILE_FAILURE");
    function saveOnFileUploadDone(successActionFn, errorActionFn) {
        return function fileUploadDone(action$, store, fetchOptions) {
            return action$.pipe((0, operators_1.filter)(function (action) {
                return action.type === successAction || action.type === failureAction;
            }), (0, operators_1.mergeMap)(function () {
                var subState = getState(store.value);
                var filesInUploading = subState.uploadedFiles;
                var itemsSoFar = Object.values(filesInUploading).filter(function (i) { return i.status === 'UPLOADED'; });
                var allDone = itemsSoFar.length === subState.currentUploadStatus.totalFiles;
                if (allDone) {
                    var session = subState.currentUploadStatus.session;
                    if (subState.modalState.isOpen && session) {
                        return (0, rxjs_1.merge)(saveMetas(session, fetchOptions, successActionFn, errorActionFn, store.value));
                    }
                }
                return (0, rxjs_1.empty)();
            }));
        };
    }
    return {
        initFileUpload: initFileUpload,
        handleUpload: handleUpload,
        handleFileUpload: handleFileUpload,
        cancelUploadSession: cancelUploadSession,
        checkDuplicateFolder: checkDuplicateFolder,
        saveOnFileUploadDone: saveOnFileUploadDone
    };
}
